import React, { useContext, useEffect, useRef } from "react";
import axios from "axios";

import { PaymentContext } from "../AppContext";

const PaypalButtons = () => {
  const [
    selectedProduct,
    setPaymentError,
    basketOpen,
    customerName,
    customerEmail,
    setBookingMade,
    numberOfChildren,
  ] = useContext(PaymentContext);

  const paypalRef = useRef();

  useEffect(() => {
    window.paypal
      .Buttons({
        style: {
          color: "blue",
          shape: "pill",
          size: "responsive",
          height: 40,
        },
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                description: selectedProduct.name,
                amount: {
                  currency_code: "GBP",
                  value: selectedProduct.price,
                },
              },
            ],
          });
        },
        onApprove: async (data, actions) => {
          await actions.order.capture();

          const bookingDetails = {
            id: selectedProduct._id,
            customerName: customerName,
            customerEmail: customerEmail,
            timeslotName: selectedProduct.name,
            numberOfChildren: numberOfChildren,
          };

          axios.post(
            "https://little-munchkin-photography.herokuapp.com/api/timeslots/book",
            bookingDetails
          );
          // axios.post(
          //   "http://localhost:5000/api/timeslots/book",
          //   bookingDetails
          // );

          setBookingMade(true);
        },
        onError: (err) => {
          setPaymentError(err);
        },
      })
      .render(paypalRef.current);
    // eslint-disable-next-line
  }, [basketOpen]);

  return (
    <div className="payment-modal">
      <div className="inner-modal">
        <div>
          <h4>Please check the following details are correct</h4>
          <p>
            Your Name - <b>{customerName}</b>
          </p>
          <p>
            Your Email Address - <b>{customerEmail}</b>
          </p>
          <p>
            Your Chosen Slot - <b>{selectedProduct.name}</b>
          </p>
          <p>
            Total to Pay - <b>£{selectedProduct.price}</b>
          </p>
        </div>
        <div ref={paypalRef} />
        <div>
          <button onClick={(e) => window.location.reload()}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default PaypalButtons;
